/* ══════════════════════════════════════════════════════════════
   Solid Color Screen — full-screen color generator
   Browser-only. No eval, no innerHTML for user data.
   ══════════════════════════════════════════════════════════════ */
(function () {
'use strict';

var T = window.__CS_T || {};
function $(id) { return document.getElementById(id); }
var reducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
function now() { return (window.performance && performance.now) ? performance.now() : Date.now(); }

/* ── iOS / Fullscreen detection ── */
var isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
var fsEl = $('csFs');
var hasFsApi = !!(fsEl && (fsEl.requestFullscreen || fsEl.webkitRequestFullscreen));

/* ── Named CSS colors (sanitize + datalist) ── */
var NAMED = {
    white:'#ffffff', black:'#000000', red:'#ff0000', green:'#008000', lime:'#00ff00',
    blue:'#0000ff', cyan:'#00ffff', aqua:'#00ffff', magenta:'#ff00ff', fuchsia:'#ff00ff',
    yellow:'#ffff00', orange:'#ffa500', purple:'#800080', pink:'#ffc0cb', gray:'#808080',
    grey:'#808080', silver:'#c0c0c0', maroon:'#800000', navy:'#000080', teal:'#008080',
    olive:'#808000', gold:'#ffd700', coral:'#ff7f50', salmon:'#fa8072', khaki:'#f0e68c',
    violet:'#ee82ee', indigo:'#4b0082', turquoise:'#40e0d0', crimson:'#dc143c',
    skyblue:'#87ceeb', tomato:'#ff6347', chartreuse:'#7fff00', orchid:'#da70d6',
    'rebeccapurple':'#663399'
};
/* Nearest-name lookup table */
var NAME_LIST = [
    ['Black','#000000'],['White','#ffffff'],['Gray','#808080'],['Silver','#c0c0c0'],['Dim gray','#696969'],
    ['Red','#ff0000'],['Dark red','#8b0000'],['Firebrick','#b22222'],['Crimson','#dc143c'],['Tomato','#ff6347'],
    ['Coral','#ff7f50'],['Salmon','#fa8072'],['Orange','#ffa500'],['Dark orange','#ff8c00'],['Gold','#ffd700'],
    ['Yellow','#ffff00'],['Khaki','#f0e68c'],['Olive','#808000'],['Lime','#00ff00'],['Green','#008000'],
    ['Forest green','#228b22'],['Sea green','#2e8b57'],['Lime green','#32cd32'],['Spring green','#00ff7f'],['Teal','#008080'],
    ['Cyan','#00ffff'],['Turquoise','#40e0d0'],['Sky blue','#87ceeb'],['Steel blue','#4682b4'],['Blue','#0000ff'],
    ['Royal blue','#4169e1'],['Navy','#000080'],['Indigo','#4b0082'],['Slate blue','#6a5acd'],['Purple','#800080'],
    ['Violet','#ee82ee'],['Magenta','#ff00ff'],['Orchid','#da70d6'],['Hot pink','#ff69b4'],['Pink','#ffc0cb'],
    ['Brown','#a52a2a'],['Saddle brown','#8b4513'],['Chocolate','#d2691e'],['Peru','#cd853f'],['Tan','#d2b48c'],
    ['Beige','#f5f5dc'],['Ivory','#fffff0'],['Lavender','#e6e6fa'],['Mint','#f5fffa'],['Maroon','#800000']
];

/* ── Preset palette (grouped by use case) ── */
var GROUPS = [
    { key:'group_pure', items:[
        ['white','#ffffff'],['black','#000000'],['red','#ff0000'],['green','#00ff00'],
        ['blue','#0000ff'],['cyan','#00ffff'],['magenta','#ff00ff'],['yellow','#ffff00'],['grey','#808080']
    ]},
    { key:'group_chroma', items:[ ['chroma_green','#00b140'],['chroma_blue','#0047bb'] ]},
    { key:'group_photo', items:[ ['warm_white','#fff4e6'],['cool_white','#eaf2ff'],['soft_white','#fff8f0'],['skin_bounce','#ffe0c2'] ]},
    { key:'group_bias', kelvin:true, items:[ ['k2700',2700],['k3400',3400],['k4500',4500],['k5600',5600],['k6500',6500],['k9000',9000] ]},
    { key:'group_night', items:[ ['night_red','#3a0000'],['night_amber','#2a1500'],['dim_warm','#1a0f05'] ]}
];

/* ═══════════════ Color math ═══════════════ */
function clamp(n, lo, hi) { return n < lo ? lo : (n > hi ? hi : n); }
function clamp255(n) { return clamp(Math.round(n), 0, 255); }
function pad2(s) { return s.length < 2 ? '0' + s : s; }
function rgbToHex(c) { return '#' + pad2(c.r.toString(16)) + pad2(c.g.toString(16)) + pad2(c.b.toString(16)); }
function hexToRgb(hex) { var h = hex.replace('#', ''); return { r: parseInt(h.slice(0,2),16), g: parseInt(h.slice(2,4),16), b: parseInt(h.slice(4,6),16) }; }
function sanitizeColor(s) {
    if (s === null || s === undefined) return null;
    s = String(s).trim();
    if (!s) return null;
    if (/^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(s)) {
        var h = s.replace('#', '').toLowerCase();
        if (h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
        else if (h.length === 4) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
        else if (h.length === 8) h = h.slice(0, 6);
        return '#' + h.slice(0, 6);
    }
    var m = s.match(/^rgba?\(\s*(\d{1,3})[,\s]+(\d{1,3})[,\s]+(\d{1,3})/i);
    if (m) return rgbToHex({ r: clamp255(+m[1]), g: clamp255(+m[2]), b: clamp255(+m[3]) });
    var name = s.toLowerCase();
    if (NAMED[name]) return NAMED[name];
    return null;
}
function rgbToHsl(c) {
    var r = c.r/255, g = c.g/255, b = c.b/255;
    var max = Math.max(r,g,b), min = Math.min(r,g,b), d = max-min;
    var h = 0, s = 0, l = (max+min)/2;
    if (d !== 0) {
        s = l > 0.5 ? d/(2-max-min) : d/(max+min);
        if (max === r) h = ((g-b)/d) % 6;
        else if (max === g) h = (b-r)/d + 2;
        else h = (r-g)/d + 4;
        h *= 60; if (h < 0) h += 360;
    }
    return { h: Math.round(h), s: Math.round(s*100), l: Math.round(l*100) };
}
function hslToRgb(hsl) {
    var h = hsl.h, s = hsl.s/100, l = hsl.l/100;
    var c = (1 - Math.abs(2*l - 1)) * s;
    var x = c * (1 - Math.abs((h/60) % 2 - 1));
    var m = l - c/2, r=0, g=0, b=0;
    if (h < 60) { r=c; g=x; } else if (h < 120) { r=x; g=c; }
    else if (h < 180) { g=c; b=x; } else if (h < 240) { g=x; b=c; }
    else if (h < 300) { r=x; b=c; } else { r=c; b=x; }
    return { r: clamp255((r+m)*255), g: clamp255((g+m)*255), b: clamp255((b+m)*255) };
}
function tempToRgb(kelvin) {
    var t = clamp(kelvin, 1000, 40000) / 100, r, g, b;
    if (t <= 66) {
        r = 255; g = 99.4708025861 * Math.log(t) - 161.1195681661;
        if (t <= 19) b = 0; else b = 138.5177312231 * Math.log(t - 10) - 305.0447927307;
    } else {
        r = 329.698727446 * Math.pow(t - 60, -0.1332047592);
        g = 288.1221695283 * Math.pow(t - 60, -0.0755148492); b = 255;
    }
    return { r: clamp255(r), g: clamp255(g), b: clamp255(b) };
}
function applyBrightness(c, k) { return { r: clamp255(c.r*k), g: clamp255(c.g*k), b: clamp255(c.b*k) }; }
function litHex(hex) { return rgbToHex(applyBrightness(hexToRgb(hex), state.brightness)); }
function relLuminance(c) {
    function lin(v) { v /= 255; return v <= 0.03928 ? v/12.92 : Math.pow((v+0.055)/1.055, 2.4); }
    return 0.2126*lin(c.r) + 0.7152*lin(c.g) + 0.0722*lin(c.b);
}
function contrastRatio(l1, l2) { var hi = Math.max(l1,l2), lo = Math.min(l1,l2); return (hi+0.05)/(lo+0.05); }
function nearestName(rgb) {
    var best = '', bd = Infinity;
    for (var i = 0; i < NAME_LIST.length; i++) {
        var c = hexToRgb(NAME_LIST[i][1]);
        var d = (c.r-rgb.r)*(c.r-rgb.r) + (c.g-rgb.g)*(c.g-rgb.g) + (c.b-rgb.b)*(c.b-rgb.b);
        if (d < bd) { bd = d; best = NAME_LIST[i][0]; }
    }
    return best;
}

/* ═══════════════ State ═══════════════ */
var state = {
    base: '#ff5500', brightness: 1, temp: 6500, tempOn: false, wakeOn: true,
    recent: [], favs: [],
    cycle: { list: [], on: false, idx: 0, interval: 3000, crossfade: true },
    gradient: { on: false, colorB: '#0047bb', type: 'linear', angle: 135 },
    isFs: false, isFaux: false, topLayer: 'A'
};
var _syncing = false;

function sourceRgb() { return state.tempOn ? tempToRgb(state.temp) : hexToRgb(state.base); }
function finalRgb() { return applyBrightness(sourceRgb(), state.brightness); }
function finalHex() { return rgbToHex(finalRgb()); }
function sourceHex() { return rgbToHex(sourceRgb()); }
function finalCss() {
    if (state.gradient.on) {
        var a = finalHex(), b = litHex(state.gradient.colorB);
        if (state.gradient.type === 'radial') return 'radial-gradient(circle at center, ' + a + ', ' + b + ')';
        return 'linear-gradient(' + state.gradient.angle + 'deg, ' + a + ', ' + b + ')';
    }
    return finalHex();
}

/* ═══════════════ Persistence ═══════════════ */
var TS = window.__toolSettings;
function save(k, v) { if (TS && TS.save) try { TS.save('color-screen', k, v); } catch (e) {} }
function load(k, fb) { return (TS && TS.load) ? TS.load('color-screen', k, fb) : fb; }

/* ═══════════════ Telemetry ═══════════════ */
function ae(ev, data) { if (window.__ae) try { window.__ae(ev, data || {}); } catch (e) {} }
function stage(s, d) { if (window.__stage) try { window.__stage(s, d || {}); } catch (e) {} }
var _completed = false;
function markComplete(how) {
    if (_completed) return; _completed = true;
    ae('tool_complete', { slug: 'color-screen', via: how });
    if (window.__aeToolComplete) try { window.__aeToolComplete(); } catch (e) {}
}

/* ═══════════════ Toast / announce ═══════════════ */
function toast(msg, type) { if (window.__toast) window.__toast(msg, type || 'success'); }
var _annTimer = null;
function announce(hex) {
    if (!window.__announce) return;
    clearTimeout(_annTimer);
    _annTimer = setTimeout(function () { window.__announce((T.announce_color || ':hex').replace(':hex', hex.toUpperCase())); }, 350);
}

/* ═══════════════ Core ═══════════════ */
function setSource(hex, opts) {
    opts = opts || {};
    var clean = sanitizeColor(hex);
    if (!clean) return;
    state.base = clean;
    if (!opts.keepTemp) state.tempOn = false;
    syncInputs();
    paint({ fade: opts.fade });
    if (!opts.silent) { addRecent(clean); save('lastColor', clean); }
    announce(finalHex());
}
function setTemp(K, opts) {
    opts = opts || {};
    state.temp = clamp(K, 1500, 12000); state.tempOn = true;
    save('temp', state.temp); save('tempOn', true);
    syncInputs(); paint({ fade: opts.fade });
    if (!opts.silent) addRecent(finalHex());
    announce(finalHex());
}
function setBrightness(pct, fromAnim) {
    if (!fromAnim) stopAnims('manual');
    state.brightness = clamp(pct, 5, 100) / 100;
    if (!fromAnim) save('brightness', Math.round(state.brightness*100));
    var bv = $('csBrightV'); if (bv) bv.textContent = Math.round(state.brightness*100) + '%';
    paint({});
}

function paint(opts) {
    opts = opts || {};
    var css = finalCss();
    var sw = $('csSwatch'); if (sw) sw.style.background = css;
    var fsHex = $('csFsHex'); if (fsHex) fsHex.textContent = finalHex().toUpperCase();
    if (state.isFs) paintLayers(css, opts.fade);
    updateReadout(); updateNative(); updateNearName();
}
function updateNative() { var nat = $('csNative'); if (nat) nat.value = sourceHex(); }
function updateNearName() { var el = $('csNearName'); if (el) el.textContent = '≈ ' + nearestName(sourceRgb()); }

function paintLayers(css, fade) {
    var layerA = $('csLayerA'), layerB = $('csLayerB');
    if (!layerA || !layerB) return;
    var top = state.topLayer === 'A' ? layerA : layerB;
    var bot = state.topLayer === 'A' ? layerB : layerA;
    if (!fade || !state.cycle.crossfade || reducedMotion) {
        top.style.transition = 'none'; top.style.background = css; top.style.opacity = '1';
        top.style.zIndex = '2'; bot.style.zIndex = '1'; return;
    }
    bot.style.transition = 'none'; bot.style.background = css; bot.style.opacity = '0';
    bot.style.zIndex = '2'; top.style.zIndex = '1';
    void bot.offsetWidth;
    bot.style.transition = 'opacity 600ms ease'; bot.style.opacity = '1';
    state.topLayer = state.topLayer === 'A' ? 'B' : 'A';
}
function initLayers(css) {
    var layerA = $('csLayerA'), layerB = $('csLayerB');
    layerA.style.transition = 'none'; layerB.style.transition = 'none';
    layerA.style.background = css; layerB.style.background = css;
    layerA.style.opacity = '1'; layerB.style.opacity = '1';
    layerA.style.zIndex = '2'; layerB.style.zIndex = '1'; state.topLayer = 'A';
}

function syncInputs() {
    _syncing = true;
    var src = sourceRgb(), hex = rgbToHex(src), hsl = rgbToHsl(src);
    setVal('csHex', hex.toUpperCase());
    setVal('csR', src.r); setVal('csRv', src.r);
    setVal('csG', src.g); setVal('csGv', src.g);
    setVal('csB', src.b); setVal('csBv', src.b);
    setVal('csH', hsl.h); setVal('csHv', hsl.h);
    setVal('csS', hsl.s); setVal('csSv', hsl.s);
    setVal('csL', hsl.l); setVal('csLv', hsl.l);
    var tv = $('csTempV'); if (tv) tv.textContent = state.temp + (T.kelvin || 'K');
    setVal('csTemp', state.temp);
    var wm = $('csWhiteMode'); if (wm) wm.checked = state.tempOn;
    updateFav();
    _syncing = false;
}
function setVal(id, v) { var el = $(id); if (el) el.value = v; }

function updateReadout() {
    var c = finalRgb(), L = relLuminance(c);
    var cw = contrastRatio(L, relLuminance({r:255,g:255,b:255}));
    var cb = contrastRatio(L, relLuminance({r:0,g:0,b:0}));
    var lum = $('csLum'); if (lum) lum.textContent = L.toFixed(3);
    setRatio('csCW', cw); setRatio('csCB', cb);
}
function setRatio(id, ratio) {
    var el = $(id); if (!el) return;
    var cls = 'fail', label = T.wcag_fail || 'Fail';
    if (ratio >= 7) { cls = 'aaa'; label = T.wcag_aaa || 'AAA'; }
    else if (ratio >= 4.5) { cls = 'aa'; label = T.wcag_aa || 'AA'; }
    else if (ratio >= 3) { cls = 'aal'; label = T.wcag_aa_large || 'AA large'; }
    el.textContent = ratio.toFixed(2) + ':1';
    var b = document.createElement('span'); b.className = 'cs-badge ' + cls; b.textContent = label;
    el.appendChild(b);
}

/* ═══════════════ Recent / favorites ═══════════════ */
/* A slider drag fires `input` on every step, and each one used to land in
   "Recent" — dragging R from 0 to 255 filled all twelve slots with shades of one
   colour, indistinguishable to the eye and useless to click. Only the colour the
   user SETTLES on is remembered: the write is deferred and the pending one is
   replaced while the drag continues. */
var _recentTimer = null, RECENT_SETTLE_MS = 700;
function addRecent(hex) {
    clearTimeout(_recentTimer);
    _recentTimer = setTimeout(function () { commitRecent(hex); }, RECENT_SETTLE_MS);
}
function commitRecent(hex) {
    hex = hex.toLowerCase();
    state.recent = state.recent.filter(function (c) { return c !== hex; });
    state.recent.unshift(hex);
    if (state.recent.length > 12) state.recent = state.recent.slice(0, 12);
    save('recent', state.recent);
    renderMini('csRecent', state.recent, false);
}
function toggleFav() {
    var hex = sourceHex().toLowerCase();
    var i = state.favs.indexOf(hex);
    if (i >= 0) state.favs.splice(i, 1); else state.favs.unshift(hex);
    if (state.favs.length > 24) state.favs = state.favs.slice(0, 24);
    save('favs', state.favs);
    renderMini('csFavs', state.favs, true);
    updateFav();
    ae('feature_use', { f: 'favorite' });
}
function updateFav() {
    var btn = $('csFav'); if (!btn) return;
    var isFav = state.favs.indexOf(sourceHex().toLowerCase()) >= 0;
    btn.classList.toggle('is-fav', isFav);
    btn.setAttribute('aria-label', isFav ? (T.remove_fav || '') : (T.add_fav || ''));
    btn.title = isFav ? (T.remove_fav || '') : (T.add_fav || '');
}
function renderMini(containerId, list, isFav) {
    var c = $(containerId); if (!c) return;
    c.textContent = '';
    if (!list.length) {
        var e = document.createElement('span');
        e.className = 'cs-empty'; e.textContent = isFav ? (T.fav_empty || '') : '—';
        c.appendChild(e); return;
    }
    list.forEach(function (hex) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'cs-mini'; b.style.background = hex;
        b.title = hex.toUpperCase(); b.setAttribute('aria-label', hex.toUpperCase());
        b.addEventListener('click', function () { setSource(hex); });
        c.appendChild(b);
    });
}

/* ═══════════════ Presets ═══════════════ */
function buildPresets() {
    var root = $('csPresets'); if (!root) return;
    GROUPS.forEach(function (group) {
        var wrap = document.createElement('div'); wrap.className = 'cs-preset-group';
        var h = document.createElement('h4'); h.textContent = T[group.key] || group.key; wrap.appendChild(h);
        var grid = document.createElement('div'); grid.className = 'cs-swatches';
        group.items.forEach(function (item) {
            var id = item[0], val = item[1];
            var hex = group.kelvin ? rgbToHex(tempToRgb(val)) : val;
            var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'cs-chip';
            var sw = document.createElement('span'); sw.className = 'cs-chip-sw'; sw.style.background = hex;
            var nm = document.createElement('span'); nm.className = 'cs-chip-name'; nm.textContent = T['name_' + id] || id;
            btn.appendChild(sw); btn.appendChild(nm); btn.title = nm.textContent;
            btn.addEventListener('click', function () {
                if (group.kelvin) setTemp(val); else setSource(hex);
                ae('feature_use', { f: 'preset', g: group.key, id: id });
            });
            grid.appendChild(btn);
        });
        wrap.appendChild(grid); root.appendChild(wrap);
    });
}
function buildDatalist() {
    var dl = $('csNamedColors'); if (!dl) return;
    Object.keys(NAMED).forEach(function (name) { var o = document.createElement('option'); o.value = name; dl.appendChild(o); });
}

/* ═══════════════ Wake Lock ═══════════════ */
var wakeLock = null;
var noSleepVideo = $('csNoSleep');
var NOSLEEP_SRC = 'data:video/mp4;base64,AAAAIGZ0eXBpc29tAAACAGlzb21pc28yYXZjMW1wNDEAAAAIZnJlZQAAABltZGF0AAACAAYG//8AEUPGAAABkODgAAAADGdBQAAAADJ0cmFrAAAAXHRraGQAAAADAAAAAAAAAAAAAAABAAAAAAAAA+gAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAABAAAAAAgAAAAIAAAAAACRlZHRzAAAAHGVsc3QAAAAAAAAAAQAAAAAAAgAAAAEAAAAABSRtZGlhAAAAIG1kaGQAAAAAAAAAAAAAAAAAACgAAAAEABXHAAAAAAAtaGRscgAAAAAAAAAAdmlkZQAAAAAAAAAAAAAAAFZpZGVvSGFuZGxlcgAAAATPbWluZgAAABR2bWhkAAAAAQAAAAAAAAAAAAAAJGRpbmYAAAAcZHJlZgAAAAAAAAABAAAADHVybCAAAAABAAAEj3N0YmwAAACzc3RzZAAAAAAAAAABAAAAo2F2YzEAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAACAAIASAAAAEgAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABj//wAAADFhdmNDAWQAAf/hABhnZAABrNlBQPohAAADAAEAAAMAKA8WLZYBAAZo6+PLIsD9+PgAAAAAFGJ0cnQAAAAAAAAD6AAAA+gAAAAYc3R0cwAAAAAAAAABAAAAAgAAAgAAAAAUc3RzcwAAAAAAAAABAAAAAQAAAChzdHNjAAAAAAAAAAEAAAABAAAAAgAAAAEAAAAcc3R6AAAAAAAAAAAAAAIAAAC0AAAADAAAABRzdGNvAAAAAAAAAAEAAAAwAAAAYnVkdGEAAABabWV0YQAAAAAAAAAhaGRscgAAAAAAAAAAbWRpcmFwcGwAAAAAAAAAAAAAAAAtaWxzdAAAACWpdG9vAAAAHWRhdGEAAAABAAAAAExhdmY1Ni40MC4xMDE=';
function requestWakeLock() {
    if (!('wakeLock' in navigator)) return Promise.reject('unsupported');
    return navigator.wakeLock.request('screen').then(function (lock) {
        wakeLock = lock;
        lock.addEventListener('release', function () { wakeLock = null; if (state.isFs && state.wakeOn) requestWakeLock().catch(function () {}); });
        return lock;
    });
}
function releaseWakeLock() { if (wakeLock) { try { wakeLock.release(); } catch (e) {} } wakeLock = null; }
function startVideoFallback() { if (!noSleepVideo) return; noSleepVideo.src = NOSLEEP_SRC; var p = noSleepVideo.play(); if (p && p.catch) p.catch(function () {}); }
function stopVideoFallback() { if (!noSleepVideo) return; noSleepVideo.pause(); noSleepVideo.removeAttribute('src'); noSleepVideo.load(); }
document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && state.isFs && state.wakeOn && !wakeLock) requestWakeLock().catch(function () {});
});

/* ═══════════════ Fullscreen ═══════════════ */
var _bodyOverflow = '', _scrollY = 0, idleTimer = null;
function enterFaux() { _bodyOverflow = document.body.style.overflow; _scrollY = window.scrollY; document.body.style.overflow = 'hidden'; window.scrollTo(0, 0); state.isFaux = true; }
function exitFaux() { document.body.style.overflow = _bodyOverflow; window.scrollTo(0, _scrollY); state.isFaux = false; }
function enterFs() {
    initLayers(finalCss());
    fsEl.classList.add('cs-fs--on'); fsEl.setAttribute('aria-hidden', 'false'); state.isFs = true;
    if (hasFsApi) { var p = (fsEl.requestFullscreen || fsEl.webkitRequestFullscreen).call(fsEl); if (p && p.catch) p.catch(function () {}); }
    else if (isIOS) enterFaux();
    if (state.wakeOn) requestWakeLock().catch(function () { startVideoFallback(); });
    var go = $('csGo'); if (go) go.classList.remove('cs-pulse');
    resetIdle(); updateCycleUI();
    stage('fullscreen'); markComplete('fullscreen');
}
function exitFs() {
    if (state.cycle.on) cyclePause();
    if (document.fullscreenElement || document.webkitFullscreenElement) { try { (document.exitFullscreen || document.webkitExitFullscreen).call(document); } catch (e) {} }
    if (state.isFaux) exitFaux();
    fsEl.classList.remove('cs-fs--on'); fsEl.setAttribute('aria-hidden', 'true'); state.isFs = false;
    clearTimeout(idleTimer); document.body.classList.remove('cs-cursor-none'); showBar();
    releaseWakeLock(); stopVideoFallback(); updateCycleUI();
}
function toggleFs() { if (state.isFs) exitFs(); else enterFs(); }
function onFsChange() { var realFs = !!(document.fullscreenElement || document.webkitFullscreenElement); if (!realFs && state.isFs && !state.isFaux) exitFs(); }
document.addEventListener('fullscreenchange', onFsChange);
document.addEventListener('webkitfullscreenchange', onFsChange);
function resetIdle() { clearTimeout(idleTimer); showBar(); document.body.classList.remove('cs-cursor-none'); if (state.isFs) idleTimer = setTimeout(hideBar, 2500); }
function hideBar() { if (!state.isFs) return; $('csBar').classList.add('cs-hidden'); $('csFsClose').classList.add('cs-hidden'); document.body.classList.add('cs-cursor-none'); }
function showBar() { $('csBar').classList.remove('cs-hidden'); $('csFsClose').classList.remove('cs-hidden'); }

/* ═══════════════ Animations (mutually exclusive: cycle | breathing | timer) ═══════════════ */
function stopAnims(except) {
    if (except !== 'cycle' && state.cycle.on) cyclePause();
    if (except !== 'breathing' && breathingRaf) stopBreathing();
    if (except !== 'timer' && timerInt) stopTimer();
}

/* ── Color cycle ── */
var cycleTimer = null;
var DEFAULT_CYCLE = ['#ff0000','#ff8800','#ffee00','#00cc44','#0088ff','#8800ff'];
/* Dead/stuck-pixel sweep. The page's own copy has always promised a screen check
   ("проверки битых пикселей"), but nothing on it ran the sweep — the user had to
   build the sequence by hand. These are the six fields the check needs: each
   primary at full drive exposes a subpixel that never lights, white exposes one
   that never goes dark, black exposes a stuck-lit one, and mid grey exposes the
   dim/bright outliers the saturated fields hide. */
var DEADPIXEL_CYCLE = ['#ff0000','#00ff00','#0000ff','#ffffff','#000000','#808080'];
function ensureCycleList() { if (state.cycle.list.length) return; state.cycle.list = DEFAULT_CYCLE.slice(); save('cycleList', state.cycle.list); renderCycleList(); }
function navList() { return state.cycle.list.length ? state.cycle.list : DEFAULT_CYCLE; }
function cyclePlay() {
    if (state.cycle.on) return cyclePause();
    stopAnims('cycle'); ensureCycleList();
    state.cycle.on = true; updateCycleUI(); scheduleCycle();
    ae('feature_use', { f: 'cycle' });
}
function cyclePause() { state.cycle.on = false; clearTimeout(cycleTimer); updateCycleUI(); }
function scheduleCycle() { clearTimeout(cycleTimer); cycleTimer = setTimeout(function () { if (!state.cycle.on) return; cycleStep(1); scheduleCycle(); }, state.cycle.interval); }
function cycleStep(dir) { var list = navList(); state.cycle.idx = (state.cycle.idx + dir + list.length) % list.length; setSource(list[state.cycle.idx], { silent: true, fade: true }); }
function updateCycleUI() {
    var play = $('csCyclePlay'); if (play) play.innerHTML = state.cycle.on ? ('⏸ ' + (T.cycle_pause || '')) : ('▶ ' + (T.cycle_play || ''));
    var bp = $('csBarPlay'); if (bp) bp.textContent = state.cycle.on ? '⏸' : '▶';
    var run = $('csRunning'); if (run) run.hidden = !(state.cycle.on && !state.isFs);
}
function renderCycleList() {
    var c = $('csCycleList'); if (!c) return; c.textContent = '';
    if (!state.cycle.list.length) { var e = document.createElement('span'); e.className = 'cs-empty'; e.textContent = T.cycle_empty || ''; c.appendChild(e); return; }
    state.cycle.list.forEach(function (hex, i) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'cs-mini'; b.style.background = hex;
        b.title = hex.toUpperCase() + ' — ×'; b.setAttribute('aria-label', hex.toUpperCase());
        b.addEventListener('click', function () { state.cycle.list.splice(i, 1); save('cycleList', state.cycle.list); renderCycleList(); });
        c.appendChild(b);
    });
}
function cycleAdd() { state.cycle.list.push(finalHex().toLowerCase()); save('cycleList', state.cycle.list); renderCycleList(); checkEpilepsy(); }

/* A valid pixel check needs the panel driven at full output and no crossfade —
   a dimmed or blended field hides exactly the pixel you are hunting for. So the
   test sets those itself rather than trusting whatever the user left behind. */
function startDeadPixelTest() {
    stopAnims('cycle');
    state.tempOn = false;
    state.brightness = 1;
    setVal('csBright', 100);
    var bv = $('csBrightV'); if (bv) bv.textContent = '100%';
    save('brightness', 100);
    if (state.gradient.on) { state.gradient.on = false; var gt = $('csGradOn'); if (gt) gt.checked = false; updateGradUI(); }
    state.cycle.list = DEADPIXEL_CYCLE.slice();
    state.cycle.idx = 0;
    state.cycle.crossfade = false;
    var cf = $('csCycleFade'); if (cf) cf.checked = false;
    state.cycle.interval = 4000;
    setVal('csCycleInterval', 4);
    var civ = $('csCycleIntervalV'); if (civ) civ.textContent = '4' + (T.cycle_seconds || 's');
    save('cycleList', state.cycle.list); save('cycleFade', false); save('cycleInterval', 4000);
    renderCycleList(); checkEpilepsy();
    setSource(state.cycle.list[0], { silent: true });
    syncInputs();
    if (!state.isFs) enterFs();
    state.cycle.on = true; updateCycleUI(); scheduleCycle();
    ae('feature_use', { f: 'deadpixel_test' }); stage('deadpixel'); markComplete('deadpixel');
}
function checkEpilepsy() { var note = $('csCycleEpilepsy'); if (!note) return; note.classList.toggle('show', state.cycle.interval < 1000 && !state.cycle.crossfade); }

/* ── Breathing (brightness pulse) ── */
var breathingRaf = 0, breathingT0 = 0;
function startBreathing() {
    if (reducedMotion) { toast(T.breathing || '', 'info'); return; }
    stopAnims('breathing');
    breathingT0 = now();
    function frame(t) {
        var ph = ((t - breathingT0) % state_breath_period()) / state_breath_period();
        var s = 0.5 - 0.5 * Math.cos(ph * 2 * Math.PI);
        var b = 0.15 + 0.85 * s;
        state.brightness = b;
        var bv = $('csBrightV'); if (bv) bv.textContent = Math.round(b*100) + '%';
        setVal('csBright', Math.round(clamp(b*100,5,100)));
        paint({});
        breathingRaf = requestAnimationFrame(frame);
    }
    breathingRaf = requestAnimationFrame(frame);
    updateBreathUI(true); ae('feature_use', { f: 'breathing' });
}
function state_breath_period() { return 8000; }
function stopBreathing() {
    if (breathingRaf) cancelAnimationFrame(breathingRaf); breathingRaf = 0;
    state.brightness = 1; setVal('csBright', 100); var bv = $('csBrightV'); if (bv) bv.textContent = '100%';
    save('brightness', 100); paint({}); updateBreathUI(false);
}
function toggleBreathing() { if (breathingRaf) stopBreathing(); else startBreathing(); }
function updateBreathUI(on) { var b = $('csBreathing'); if (b) { b.classList.toggle('cs-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); } }

/* ── Sleep / sunset dimming timer ── */
var timerInt = 0, timerT0 = 0, timerTotal = 0, timerStartB = 1;
function startTimer() {
    var min = clamp(parseInt(($('csTimerMin') || {}).value, 10) || 15, 1, 180);
    stopAnims('timer');
    timerTotal = min * 60000; timerT0 = now(); timerStartB = state.brightness > 0.1 ? state.brightness : 1;
    timerInt = setInterval(function () {
        var el = now() - timerT0, frac = Math.min(1, el / timerTotal);
        state.brightness = Math.max(0, timerStartB * (1 - frac));
        var pct = Math.round(state.brightness * 100);
        var bv = $('csBrightV'); if (bv) bv.textContent = pct + '%';
        setVal('csBright', clamp(pct, 5, 100));
        paint({});
        var remMin = Math.ceil((timerTotal - el) / 60000);
        updateTimerUI(true, remMin);
        if (frac >= 1) { stopTimer(); }
    }, 250);
    updateTimerUI(true, min);
    ae('feature_use', { f: 'sleep_timer', min: min }); markComplete('sleep_timer');
}
function stopTimer() {
    if (timerInt) clearInterval(timerInt); timerInt = 0;
    updateTimerUI(false, 0);
}
function toggleTimer() { if (timerInt) stopTimer(); else startTimer(); }
function updateTimerUI(on, remMin) {
    var btn = $('csTimerBtn'); if (btn) btn.textContent = on ? ('■ ' + (T.timer_stop || '')) : ('▶ ' + (T.timer_start || ''));
    var lab = $('csTimerRemain');
    if (lab) { if (on) { lab.hidden = false; lab.textContent = (T.timer_remaining || ':m').replace(':m', remMin); } else lab.hidden = true; }
}

/* ═══════════════ Quick actions ═══════════════ */
function flashlight() {
    stopAnims('manual');
    state.tempOn = false; state.brightness = 1; setVal('csBright', 100);
    var bv = $('csBrightV'); if (bv) bv.textContent = '100%'; save('brightness', 100);
    if (state.gradient.on) { state.gradient.on = false; var gt = $('csGradOn'); if (gt) gt.checked = false; updateGradUI(); }
    setSource('#ffffff'); if (!state.isFs) enterFs();
    ae('feature_use', { f: 'flashlight' });
}
function randomColor() { var n = Math.floor(Math.random() * 16777216); setSource('#' + ('00000' + n.toString(16)).slice(-6)); ae('feature_use', { f: 'random' }); }

/* ═══════════════ Gradient ═══════════════ */
function updateGradUI() {
    var on = state.gradient.on;
    var b = $('csGradB'); if (b) b.value = state.gradient.colorB;
    var ty = $('csGradType'); if (ty) ty.value = state.gradient.type;
    var an = $('csGradAngle'); if (an) an.value = state.gradient.angle;
    var av = $('csGradAngleV'); if (av) av.textContent = state.gradient.angle + '°';
    var ctl = $('csGradControls'); if (ctl) ctl.style.display = on ? '' : 'none';
    var angleRow = $('csGradAngleRow'); if (angleRow) angleRow.style.display = (on && state.gradient.type === 'linear') ? '' : 'none';
    var chk = $('csGradOn'); if (chk) chk.checked = on;
}

/* ═══════════════ Outputs ═══════════════ */
function copyText(txt, label) {
    function done() { toast((T.copied || ':value copied').replace(':value', label || txt)); }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(done).catch(fb);
    else fb();
    function fb() {
        var ta = document.createElement('textarea'); ta.value = txt; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); done(); } catch (e) {}
        document.body.removeChild(ta);
    }
}
function copyHex() { copyText(finalHex().toUpperCase(), finalHex().toUpperCase()); ae('feature_use', { f: 'copy_hex' }); markComplete('copy'); }
function copyRgb() { var c = finalRgb(); copyText('rgb(' + c.r + ', ' + c.g + ', ' + c.b + ')'); ae('feature_use', { f: 'copy_rgb' }); }
function copyHsl() { var h = rgbToHsl(finalRgb()); copyText('hsl(' + h.h + ', ' + h.s + '%, ' + h.l + '%)'); ae('feature_use', { f: 'copy_hsl' }); }
function buildUrl(withFs) {
    var u = location.origin + location.pathname + '?c=' + finalHex().replace('#', '');
    if (state.gradient.on) {
        u += '&c2=' + litHex(state.gradient.colorB).replace('#', '') + '&g=' + state.gradient.type;
        if (state.gradient.type === 'linear') u += '&ga=' + state.gradient.angle;
    }
    if (withFs) u += '&fs=1';
    return u;
}
function copyLink() { copyText(buildUrl(false), T.link_copied || ''); ae('feature_use', { f: 'copy_link' }); markComplete('link'); }
function savePng() {
    var sel = $('csRes'); var dim = (sel ? sel.value : '1920x1080').split('x');
    var w = parseInt(dim[0], 10) || 1920, h = parseInt(dim[1], 10) || 1080;
    var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
    var ctx = cv.getContext('2d');
    if (state.gradient.on) {
        var a = finalHex(), b = litHex(state.gradient.colorB), grad;
        if (state.gradient.type === 'radial') grad = ctx.createRadialGradient(w/2, h/2, 0, w/2, h/2, Math.max(w, h)/1.5);
        else { var ang = (state.gradient.angle - 90) * Math.PI/180, dx = Math.cos(ang), dy = Math.sin(ang); grad = ctx.createLinearGradient(w/2 - dx*w/2, h/2 - dy*h/2, w/2 + dx*w/2, h/2 + dy*h/2); }
        grad.addColorStop(0, a); grad.addColorStop(1, b); ctx.fillStyle = grad;
    } else ctx.fillStyle = finalHex();
    ctx.fillRect(0, 0, w, h);
    cv.toBlob(function (blob) { if (!blob) return; var name = 'color-' + finalHex().replace('#', '') + '-' + w + 'x' + h + '.png'; if (window.__downloadFile) window.__downloadFile(blob, name); }, 'image/png');
    ae('feature_use', { f: 'png' }); markComplete('png');
}
function doPrint() {
    var sheets = $('csPrintSheets'); if (!sheets) return;
    var n = clamp(parseInt(($('csCount') || {}).value, 10) || 1, 1, 20);
    var paper = $('csPaper') ? $('csPaper').value : 'A4';
    var orient = $('csOrient') ? $('csOrient').value : 'portrait';
    var css = finalCss();
    sheets.textContent = '';
    for (var i = 0; i < n; i++) { var d = document.createElement('div'); d.className = 'cs-sheet'; d.style.background = css; sheets.appendChild(d); }
    var styleEl = $('csPageStyle'); if (!styleEl) { styleEl = document.createElement('style'); styleEl.id = 'csPageStyle'; document.head.appendChild(styleEl); }
    styleEl.textContent = '@media print{ @page{ size:' + paper + ' ' + orient + '; margin:0 } }';
    ae('feature_use', { f: 'print', n: n, paper: paper, orient: orient }); markComplete('print');
    window.print();
}
function openSecondScreen() {
    if (!('getScreenDetails' in window)) return;
    window.getScreenDetails().then(function (sd) {
        var ext = null, i;
        for (i = 0; i < sd.screens.length; i++) { if (!sd.screens[i].isPrimary) { ext = sd.screens[i]; break; } }
        if (!ext) { toast(T.second_screen_hint || '', 'info'); return; }
        window.open(buildUrl(true), '_blank', 'left=' + ext.availLeft + ',top=' + ext.availTop + ',width=' + ext.availWidth + ',height=' + ext.availHeight);
        ae('feature_use', { f: 'second_screen' });
    }).catch(function () { toast(T.second_screen_hint || '', 'info'); });
}

/* ═══════════════ Tabs ═══════════════ */
function wireTabs() {
    var tabs = Array.prototype.slice.call(document.querySelectorAll('.cs-tab'));
    var panels = Array.prototype.slice.call(document.querySelectorAll('.cs-tabpanel'));
    function activate(name) {
        tabs.forEach(function (t) { var on = t.getAttribute('data-tab') === name; t.classList.toggle('active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        panels.forEach(function (p) { p.classList.toggle('active', p.getAttribute('data-panel') === name); });
        save('tab', name);
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { activate(t.getAttribute('data-tab')); }); });
    var last = load('tab', 'color');
    if (last && last !== 'color' && document.querySelector('.cs-tab[data-tab="' + last + '"]')) activate(last);
}

/* ═══════════════ Event wiring ═══════════════ */
function onHexInput() { if (_syncing) return; var clean = sanitizeColor(this.value); if (clean) setSource(clean); }
function rgbFromInputs() { return { r: clamp255(+$('csRv').value || +$('csR').value), g: clamp255(+$('csGv').value || +$('csG').value), b: clamp255(+$('csBv').value || +$('csB').value) }; }
function onRgbInput(rangeId, numId) { return function () { if (_syncing) return; var v = clamp255(+this.value); $(rangeId).value = v; $(numId).value = v; setSource(rgbToHex(rgbFromInputs())); }; }
function hslFromInputs() { return { h: clamp(+$('csHv').value || +$('csH').value, 0, 360), s: clamp(+$('csSv').value || +$('csS').value, 0, 100), l: clamp(+$('csLv').value || +$('csL').value, 0, 100) }; }
function onHslInput(rangeId, numId, max) { return function () { if (_syncing) return; var v = clamp(+this.value, 0, max); $(rangeId).value = v; $(numId).value = v; setSource(rgbToHex(hslToRgb(hslFromInputs()))); }; }

function wire() {
    $('csHex').addEventListener('input', onHexInput);
    $('csHex').addEventListener('change', function () { if (!sanitizeColor(this.value)) this.value = sourceHex().toUpperCase(); });
    $('csNative').addEventListener('input', function () { if (!_syncing) setSource(this.value); });
    $('csFav').addEventListener('click', toggleFav);

    var eye = $('csEyedrop');
    if (typeof window.EyeDropper === 'function' && eye) {
        eye.hidden = false;
        eye.addEventListener('click', function () {
            try { new window.EyeDropper().open().then(function (res) { setSource(res.sRGBHex); ae('feature_use', { f: 'eyedropper' }); }).catch(function () {}); } catch (e) {}
        });
    }

    $('csR').addEventListener('input', onRgbInput('csR', 'csRv'));
    $('csRv').addEventListener('input', onRgbInput('csR', 'csRv'));
    $('csG').addEventListener('input', onRgbInput('csG', 'csGv'));
    $('csGv').addEventListener('input', onRgbInput('csG', 'csGv'));
    $('csB').addEventListener('input', onRgbInput('csB', 'csBv'));
    $('csBv').addEventListener('input', onRgbInput('csB', 'csBv'));
    $('csH').addEventListener('input', onHslInput('csH', 'csHv', 360));
    $('csHv').addEventListener('input', onHslInput('csH', 'csHv', 360));
    $('csS').addEventListener('input', onHslInput('csS', 'csSv', 100));
    $('csSv').addEventListener('input', onHslInput('csS', 'csSv', 100));
    $('csL').addEventListener('input', onHslInput('csL', 'csLv', 100));
    $('csLv').addEventListener('input', onHslInput('csL', 'csLv', 100));

    $('csBright').addEventListener('input', function () { setBrightness(+this.value); });
    $('csTemp').addEventListener('input', function () { setTemp(+this.value); });
    $('csWhiteMode').addEventListener('change', function () { state.tempOn = this.checked; save('tempOn', state.tempOn); syncInputs(); paint({}); if (!state.tempOn) save('lastColor', state.base); });
    $('csFlashlight').addEventListener('click', flashlight);
    $('csRandom').addEventListener('click', randomColor);
    var br = $('csBreathing'); if (br) br.addEventListener('click', toggleBreathing);
    var tb = $('csTimerBtn'); if (tb) tb.addEventListener('click', toggleTimer);

    // Gradient
    var gOn = $('csGradOn');
    if (gOn) gOn.addEventListener('change', function () {
        state.gradient.on = this.checked; save('gradOn', this.checked); updateGradUI(); paint({});
        ae('feature_use', { f: 'gradient', on: this.checked });
    });
    var gB = $('csGradB'); if (gB) gB.addEventListener('input', function () { state.gradient.colorB = sanitizeColor(this.value) || state.gradient.colorB; save('gradB', state.gradient.colorB); paint({}); });
    var gT = $('csGradType'); if (gT) gT.addEventListener('change', function () { state.gradient.type = this.value === 'radial' ? 'radial' : 'linear'; save('gradType', state.gradient.type); updateGradUI(); paint({}); });
    var gA = $('csGradAngle'); if (gA) gA.addEventListener('input', function () { state.gradient.angle = clamp(+this.value, 0, 360); save('gradAngle', state.gradient.angle); var av = $('csGradAngleV'); if (av) av.textContent = state.gradient.angle + '°'; paint({}); });

    $('csCopyHex').addEventListener('click', copyHex);
    $('csCopyRgb').addEventListener('click', copyRgb);
    $('csCopyHsl').addEventListener('click', copyHsl);
    $('csCopyLink').addEventListener('click', copyLink);
    $('csSavePng').addEventListener('click', savePng);
    $('csPrint').addEventListener('click', doPrint);
    $('csGo').addEventListener('click', enterFs);

    var sw = $('csSwatch');
    sw.addEventListener('click', enterFs);
    sw.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); enterFs(); } });

    $('csWake').addEventListener('change', function () {
        state.wakeOn = this.checked; save('wakeOn', state.wakeOn);
        if (state.isFs) { if (state.wakeOn) requestWakeLock().catch(function () { startVideoFallback(); }); else { releaseWakeLock(); stopVideoFallback(); } }
    });
    if ('getScreenDetails' in window) { var sec = $('csSecond'); if (sec) { sec.hidden = false; sec.addEventListener('click', openSecondScreen); } }

    var dpx = $('csDeadPixel'); if (dpx) dpx.addEventListener('click', startDeadPixelTest);
    $('csCycleAdd').addEventListener('click', cycleAdd);
    $('csCycleClear').addEventListener('click', function () { state.cycle.list = []; save('cycleList', []); renderCycleList(); checkEpilepsy(); });
    $('csCycleInterval').addEventListener('input', function () { state.cycle.interval = Math.round(parseFloat(this.value) * 1000); $('csCycleIntervalV').textContent = parseFloat(this.value) + (T.cycle_seconds || 's'); save('cycleInterval', state.cycle.interval); checkEpilepsy(); if (state.cycle.on) scheduleCycle(); });
    $('csCycleFade').addEventListener('change', function () { state.cycle.crossfade = this.checked; save('cycleFade', this.checked); checkEpilepsy(); });
    $('csCyclePlay').addEventListener('click', cyclePlay);
    $('csCyclePrev').addEventListener('click', function () { cycleStep(-1); });
    $('csCycleNext').addEventListener('click', function () { cycleStep(1); });
    $('csRunningStop').addEventListener('click', cyclePause);

    $('csBarPrev').addEventListener('click', stop(function () { cycleStep(-1); }));
    $('csBarNext').addEventListener('click', stop(function () { cycleStep(1); }));
    $('csBarBdn').addEventListener('click', stop(function () { stepBright(-5); }));
    $('csBarBup').addEventListener('click', stop(function () { stepBright(5); }));
    $('csBarPlay').addEventListener('click', stop(cyclePlay));
    $('csBarCopy').addEventListener('click', stop(copyHex));
    $('csFsClose').addEventListener('click', stop(exitFs));
    $('csBar').addEventListener('click', function (e) { e.stopPropagation(); });

    ['mousemove', 'touchstart', 'pointerdown'].forEach(function (ev) { fsEl.addEventListener(ev, function () { if (state.isFs) resetIdle(); }, { passive: true }); });

    document.addEventListener('keydown', onKey);
    window.addEventListener('afterprint', function () { var s = $('csPrintSheets'); if (s) s.textContent = ''; });
}
function stop(fn) { return function (e) { e.stopPropagation(); fn(); }; }
function stepBright(delta) { stopAnims('manual'); var v = clamp(Math.round(state.brightness*100) + delta, 5, 100); $('csBright').value = v; setBrightness(v); }
function onKey(e) {
    var tag = (e.target && e.target.tagName) || '';
    var typing = /^(INPUT|SELECT|TEXTAREA)$/.test(tag);
    var k = e.key;
    if (k === 'Escape') { if (state.isFs) exitFs(); return; }
    if (typing) return;
    var lk = k.length === 1 ? k.toLowerCase() : k;
    switch (lk) {
        case 'f': e.preventDefault(); toggleFs(); break;
        case ' ': e.preventDefault(); cyclePlay(); break;
        case 'arrowright': e.preventDefault(); cycleStep(1); break;
        case 'arrowleft': e.preventDefault(); cycleStep(-1); break;
        case 'c': copyHex(); break;
        case '+': case '=': e.preventDefault(); stepBright(5); break;
        case '-': case '_': e.preventDefault(); stepBright(-5); break;
        case 'r': setSource('#ff0000'); break;
        case 'g': setSource('#00ff00'); break;
        case 'b': setSource('#0000ff'); break;
        case 'w': setSource('#ffffff'); break;
        case 'k': setSource('#000000'); break;
        default: break;
    }
}

/* ═══════════════ Boot ═══════════════ */
function parseInitial() {
    var autoFs = false;
    try {
        var url = new URL(location.href);
        var c = url.searchParams.get('c');
        if (!c && location.hash && location.hash.length > 1) c = location.hash.slice(1);
        var clean = sanitizeColor(c);
        if (clean) setSource(clean, { silent: true });
        var c2 = sanitizeColor(url.searchParams.get('c2'));
        var g = url.searchParams.get('g');
        if (c2 && (g === 'linear' || g === 'radial')) {
            state.gradient.colorB = c2; state.gradient.type = g;
            var ga = parseInt(url.searchParams.get('ga'), 10); if (!isNaN(ga)) state.gradient.angle = clamp(ga, 0, 360);
            state.gradient.on = true;
        }
        if (url.searchParams.get('fs') === '1') autoFs = true;
    } catch (e) {}
    return autoFs;
}
function sanitizeList(arr) { if (!Array.isArray(arr)) return []; var out = []; arr.forEach(function (x) { var c = sanitizeColor(x); if (c) out.push(c.toLowerCase()); }); return out; }
function boot() {
    if (fsEl && fsEl.parentNode !== document.body) document.body.appendChild(fsEl);
    var psEl = $('csPrintSheets'); if (psEl && psEl.parentNode !== document.body) document.body.appendChild(psEl);

    state.recent = sanitizeList(load('recent', []));
    state.favs = sanitizeList(load('favs', []));
    state.cycle.list = sanitizeList(load('cycleList', []));
    state.brightness = clamp(load('brightness', 100), 5, 100) / 100;
    state.temp = clamp(load('temp', 6500), 1500, 12000);
    state.wakeOn = load('wakeOn', true) !== false;
    state.cycle.interval = clamp(load('cycleInterval', 3000), 500, 30000);
    state.cycle.crossfade = load('cycleFade', true) !== false;
    var gb = sanitizeColor(load('gradB', '#0047bb')); if (gb) state.gradient.colorB = gb;
    var gtype = load('gradType', 'linear'); state.gradient.type = gtype === 'radial' ? 'radial' : 'linear';
    state.gradient.angle = clamp(load('gradAngle', 135), 0, 360);
    var lastColor = sanitizeColor(load('lastColor', '#ff5500')); if (lastColor) state.base = lastColor;

    setVal('csBright', Math.round(state.brightness*100));
    var bv = $('csBrightV'); if (bv) bv.textContent = Math.round(state.brightness*100) + '%';
    setVal('csTemp', state.temp);
    var wk = $('csWake'); if (wk) wk.checked = state.wakeOn;
    setVal('csCycleInterval', state.cycle.interval / 1000);
    var civ = $('csCycleIntervalV'); if (civ) civ.textContent = (state.cycle.interval/1000) + (T.cycle_seconds || 's');
    var cf = $('csCycleFade'); if (cf) cf.checked = state.cycle.crossfade;

    if (('ontouchstart' in window) || navigator.maxTouchPoints > 0) { var hint = $('csFsHint'); if (hint && T.fs_hint_touch) hint.textContent = T.fs_hint_touch; }

    buildPresets(); buildDatalist(); wireTabs();
    var autoFs = parseInitial();
    updateGradUI();

    syncInputs(); paint({});
    renderMini('csRecent', state.recent, false);
    renderMini('csFavs', state.favs, true);
    renderCycleList(); checkEpilepsy(); updateCycleUI();
    wire();

    // (No Timbrica3D.init here: that is the 3D-printing core and a silent no-op
    //  on an ordinary tool — telemetry runs through __ae / __stage above.)
    stage('ready');
    if (autoFs) { var go = $('csGo'); if (go) go.classList.add('cs-pulse'); }
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();

})();
